// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_job_cap.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_job_cap.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowJobCap$Type extends MessageType {
    constructor() {
        super("CallWindowJobCap", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "max_per_day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "day_of_week", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.maxPerDay = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.dayOfWeek = 0;
        message.eventTradeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 3:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 max_per_day */ 4:
                    message.maxPerDay = reader.int32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 6:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 10:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 11:
                    message.orderDir = reader.string();
                    break;
                case /* int32 day_of_week */ 12:
                    message.dayOfWeek = reader.int32();
                    break;
                case /* int32 event_trade_id */ 13:
                    message.eventTradeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 3; */
        if (message.jobTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobTypeId);
        /* int32 max_per_day = 4; */
        if (message.maxPerDay !== 0)
            writer.tag(4, WireType.Varint).int32(message.maxPerDay);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 6; */
        if (message.updatedAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 10; */
        if (message.orderBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 11; */
        if (message.orderDir !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderDir);
        /* int32 day_of_week = 12; */
        if (message.dayOfWeek !== 0)
            writer.tag(12, WireType.Varint).int32(message.dayOfWeek);
        /* int32 event_trade_id = 13; */
        if (message.eventTradeId !== 0)
            writer.tag(13, WireType.Varint).int32(message.eventTradeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowJobCap
 */
export const CallWindowJobCap = new CallWindowJobCap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowJobCapList$Type extends MessageType {
    constructor() {
        super("CallWindowJobCapList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallWindowJobCap },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CallWindowJobCap results */ 1:
                    message.results.push(CallWindowJobCap.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CallWindowJobCap results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CallWindowJobCap.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowJobCapList
 */
export const CallWindowJobCapList = new CallWindowJobCapList$Type();
/**
 * @generated ServiceType for protobuf service CallWindowJobCapService
 */
export const CallWindowJobCapService = new ServiceType("CallWindowJobCapService", [
    { name: "CreateCallWindowJobCap", options: {}, I: CallWindowJobCap, O: CallWindowJobCap },
    { name: "GetCallWindowJobCap", options: {}, I: CallWindowJobCap, O: CallWindowJobCap },
    { name: "BatchGetCallWindowJobCap", options: {}, I: CallWindowJobCap, O: CallWindowJobCapList },
    { name: "UpdateCallWindowJobCap", options: {}, I: CallWindowJobCap, O: CallWindowJobCap },
    { name: "DeleteCallWindowJobCap", options: {}, I: CallWindowJobCap, O: Empty }
]);
